export const querySizeMappings = {
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1424,
} satisfies Record<string, number>;
